import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
function PolicyModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-50">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-51">
        <div className="sticky top-0 bg-white border-b border-brand-gray/10 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-52">
          <h2 className="text-xl font-bold text-brand-gray" data-id="element-53">{title}</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-brand-gray/10 transition-colors" aria-label="Cerrar" data-id="element-54">
            <XIcon className="w-5 h-5 text-brand-gray" data-id="element-55" />
          </button>
        </div>
        <div className="px-6 py-6 text-brand-gray/80 text-sm leading-relaxed space-y-4" data-id="element-56">
          {children}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-brand-gray text-brand-cream/60 py-12 px-6 text-center text-sm" data-id="element-57">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-58">
          <p data-id="element-59">
            © {new Date().getFullYear()} Cocina Anti-Inflamatoria. Todos los
            derechos reservados.
          </p>
          <p className="text-xs opacity-70 max-w-2xl mx-auto" data-id="element-60">
            Descargo de responsabilidad: La información proporcionada en este
            sitio web y en la guía es solo para fines educativos e informativos.
            No pretende sustituir el consejo, diagnóstico o tratamiento médico
            profesional. Siempre busque el consejo de su médico u otro proveedor
            de salud calificado con cualquier pregunta que pueda tener sobre una
            condición médica.
          </p>
          <div className="flex items-center justify-center gap-4 pt-2" data-id="element-61">
            <button onClick={() => setShowPrivacy(true)} className="underline underline-offset-2 hover:text-brand-cream transition-colors cursor-pointer" data-id="element-62">
              Política de Privacidad
            </button>
            <span className="opacity-40" data-id="element-63">|</span>
            <button onClick={() => setShowTerms(true)} className="underline underline-offset-2 hover:text-brand-cream transition-colors cursor-pointer" data-id="element-64">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <PolicyModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-65">
        <p data-id="element-66">
          <strong data-id="element-67">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-68">
          En Cocina Anti-Inflamatoria, respetamos y protegemos la privacidad de
          nuestros usuarios. Esta política describe cómo recopilamos, usamos y
          protegemos su información personal.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-69">
          1. Información que recopilamos
        </h3>
        <p data-id="element-70">
          Podemos recopilar información personal como su nombre y dirección de
          correo electrónico cuando realiza una compra o se suscribe a nuestro
          boletín. También recopilamos datos de navegación anónimos para mejorar
          la experiencia del usuario.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-71">
          2. Uso de la información
        </h3>
        <p data-id="element-72">
          Utilizamos su información para procesar pedidos, enviar
          actualizaciones sobre productos y mejorar nuestros servicios. No
          vendemos ni compartimos su información personal con terceros, excepto
          cuando sea necesario para completar una transacción.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-73">3. Cookies</h3>
        <p data-id="element-74">
          Nuestro sitio web utiliza cookies para mejorar su experiencia de
          navegación y analizar el tráfico del sitio. Puede desactivar las
          cookies en la configuración de su navegador.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-75">4. Seguridad</h3>
        <p data-id="element-76">
          Implementamos medidas de seguridad razonables para proteger su
          información personal contra acceso no autorizado, alteración o
          destrucción.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-77">5. Sus derechos</h3>
        <p data-id="element-78">
          Usted tiene derecho a acceder, corregir o eliminar su información
          personal en cualquier momento. Para ejercer estos derechos, puede
          comunicarse con nosotros a través de los canales disponibles en
          nuestro sitio.
        </p>
      </PolicyModal>

      <PolicyModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-79">
        <p data-id="element-80">
          <strong data-id="element-81">Última actualización:</strong> Abril 2026
        </p>
        <p data-id="element-82">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, usted acepta los siguientes términos y condiciones.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-83">
          1. Productos digitales
        </h3>
        <p data-id="element-84">
          Nuestros productos son guías digitales descargables. Una vez
          completada la compra, recibirá acceso inmediato al contenido. Debido a
          la naturaleza digital del producto, no se aceptan devoluciones ni
          reembolsos.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-85">2. Uso personal</h3>
        <p data-id="element-86">
          El contenido adquirido es para uso personal y no comercial. Queda
          prohibida la reproducción, distribución o reventa del material sin
          autorización previa por escrito.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-87">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-88">
          La información contenida en nuestras guías es solo para fines
          educativos e informativos. No constituye consejo médico profesional.
          Siempre consulte a un profesional de la salud antes de realizar
          cambios en su dieta o estilo de vida.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-89">
          4. Propiedad intelectual
        </h3>
        <p data-id="element-90">
          Todo el contenido de este sitio web, incluyendo textos, imágenes,
          diseños y logotipos, es propiedad de Cocina Anti-Inflamatoria y está
          protegido por las leyes de propiedad intelectual aplicables.
        </p>
        <h3 className="font-semibold text-brand-gray pt-2" data-id="element-91">
          5. Modificaciones
        </h3>
        <p data-id="element-92">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en este sitio web.
        </p>
      </PolicyModal>
    </>;
}